import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2496826e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onMouseover"]
const _hoisted_2 = {
  key: 1,
  class: "brazzers__info"
}

import { computed, Ref, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseBrazzersCarousel',
  props: {
    maxSliders: { default: 5 },
    photos: {},
    borderRadius: { type: Boolean },
    width: {},
    height: {},
    version: {},
    alt: {},
    title: {}
  },
  setup(__props: any) {

const props = __props;

const preparedPhotos = computed(() => {
  if (!props.photos) {
    return [];
  }
  if (props.photos.length > props.maxSliders) {
    morePhotoInfo.value = `Ещё ${props.photos.length - props.maxSliders} фото`;

    return props.photos.slice(0, props.maxSliders);
  } else {
    return [...props.photos];
  }
});
const morePhotoInfo: Ref<string | null> = ref(null);

const forceCoverPhoto: Ref<string | null> = ref(null);

const coverSrc = computed(() => {
  if (forceCoverPhoto.value) {
    return forceCoverPhoto.value;
  }
  if (preparedPhotos.value.length > 0) {
    return preparedPhotos.value[0];
  }

  return require('@/assets/img/common/not-image.jpg');
});

const mouseOver = (photo: string) => {
  forceCoverPhoto.value = photo;
};
const mouseLeave = () => {
  forceCoverPhoto.value = null;
};

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[
      {
        borderRadius: _ctx.borderRadius,
      },
    ], "brazzers"]),
    style: _normalizeStyle([
      {
        width: _ctx.width === '100%' ? _ctx.width : _ctx.width + 'px',
        height: _ctx.height + 'px',
      },
    ])
  }, [
    _createVNode(_component_base_image, {
      borderRadius: _ctx.borderRadius,
      height: _ctx.height,
      name: _ctx.alt,
      src: coverSrc.value,
      title: _ctx.title,
      version: _ctx.version,
      width: _ctx.width,
      class: "brazzers__cover",
      cover: ""
    }, null, 8, ["borderRadius", "height", "name", "src", "title", "version", "width"]),
    (preparedPhotos.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "brazzers__button-container",
          onMouseleave: mouseLeave
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preparedPhotos.value, (photo, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "brazzers__button",
              onMouseover: ($event: any) => (mouseOver(photo))
            }, null, 40, _hoisted_1))
          }), 128))
        ], 32))
      : _createCommentVNode("", true),
    (morePhotoInfo.value && coverSrc.value === preparedPhotos.value[preparedPhotos.value.length - 1])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(morePhotoInfo.value), 1))
      : _createCommentVNode("", true)
  ], 6))
}
}

})